import React, { memo } from "react";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import {
    canceledHandleButton,
    handleValidateButtonOnClickEvent,
} from "../../hooks";
import { useFetchGlobal } from "../../../../../../api/hooks";

export const FooterActions = memo(
    ({
        t,
        isValidateButtonDisabled,
        isConsult,
        isEdited,
        setIsEdited,
        setDataChoice,
        setIsAddChoiceClicked,
        isAddChoiceClicked,
        setIsConsult,
        isActionsClicked,
        setIsValidateButtonDisabled,
        i18nextLng,
        archivedModesInFranchise,
        choiceMode,
        setInputChoiceMode,
        advancedDisplayName,
        setInputDisplay,
        countryData,
        setSelectCountry,
        salesSupport,
        setInputSaleSupport,
        isNameExist,
        paymentMethod,
        allDataShops,
        tagsData,
        isModalOpened,
        userData,
        setIsModalOpened,
        allAssociatedCountryShop,
        countryList,
        oneShop,
        shopsPaymentMethodsData,
        setIdsAssociated,
        identifier,
        setIsPaymentMethodAssociatedModified,
        setIsMessageModalOpened,
        isMessageModalOpened,
        display,
        paymentMethodList,
        dataArchive,
        listFranchiseArchived,
        operatorID,
        setIsSendingTag,
        uuidUser,
        setTagsData,
        setCountryData,
        setSalesSupport,
        setAdvancedDisplayName,
        setLocalFilterActive,
        itemsDisable,
        originPaymentMethodList,
    }: any) => {
        const { fetchGlobal } = useFetchGlobal();
        return (
            <>
                <CustomSecondaryColorButton
                    outline
                    rounded
                    className="mr-2 mdr_btn_FRcancel cmn_btn_cancel"
                    variant="light"
                    onClick={() =>
                        canceledHandleButton(
                            isEdited,
                            setIsEdited,
                            setDataChoice,
                            setIsAddChoiceClicked,
                            isAddChoiceClicked,
                            setIsConsult,
                            isActionsClicked
                        )
                    }
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>

                <CustomMainColorButton
                    disabled={isValidateButtonDisabled}
                    rounded
                    className={`mdr_btn_FRvalidate cmn_btn_validate ${
                        isConsult ? "not-allowed-input-vr__clz" : ""
                    }`}
                    onClick={() => {
                        setIsValidateButtonDisabled(true);
                        handleValidateButtonOnClickEvent(
                            i18nextLng,
                            archivedModesInFranchise,
                            choiceMode,
                            setInputChoiceMode,
                            setIsValidateButtonDisabled,
                            advancedDisplayName,
                            setInputDisplay,
                            countryData,
                            setSelectCountry,
                            salesSupport,
                            setInputSaleSupport,
                            isNameExist,
                            paymentMethod,
                            allDataShops,
                            tagsData,
                            isModalOpened,
                            userData,
                            setIsModalOpened,
                            allAssociatedCountryShop,
                            countryList,
                            oneShop,
                            shopsPaymentMethodsData,
                            setIdsAssociated,
                            identifier,
                            setIsPaymentMethodAssociatedModified,
                            setIsMessageModalOpened,
                            isMessageModalOpened,
                            display,
                            paymentMethodList,
                            dataArchive,
                            listFranchiseArchived,
                            operatorID,
                            setIsSendingTag,
                            uuidUser,
                            setDataChoice,
                            setIsEdited,
                            setTagsData,
                            setCountryData,
                            setSalesSupport,
                            setAdvancedDisplayName,
                            setIsAddChoiceClicked,
                            isAddChoiceClicked,
                            setLocalFilterActive,
                            itemsDisable,
                            originPaymentMethodList,
                            fetchGlobal
                        );
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </>
        );
    }
);
